function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @file 配置
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/config
 */
import cookie from './cookie';
import { extend, toQuery } from './json';
import getEnv, { isInGaoTuApp, isTestReg } from './env';
import loadScript from './loadScript';
import delay from './delay';
import getReqIdx from './requestIndex';
import uuid from './uuid';
import { commonParamsFromApp, isPlainObj } from './appCommonParam';
var isClient = typeof window !== 'undefined';

var _ref = isClient && location,
    _ref$hostname = _ref.hostname,
    hostname = _ref$hostname === void 0 ? '' : _ref$hostname; // 用于临时验证线上日志是否符合预期，手动在本地中加一个cookie isSwitchTestToProd 不为空即可


var isSwitchTestToProd = cookie.get('isSwitchTestToProd'); // 上报的域名

var DOMAIN = '//i.gsxtj.com/';
var QINGZHOU_DOMAIN = '//qingzhou-fe.baijia.com/';

if (isTestReg.test(hostname) && !isSwitchTestToProd) {
  DOMAIN = DOMAIN.replace('//', '//test-');
  QINGZHOU_DOMAIN = QINGZHOU_DOMAIN.replace('//', '//test-');
}
/**
 * 上报的公共字段 name 的值
 *
 * @const {string}
 */


var NAME = function (host) {
  return {
    baijiahulian: ''
  }[host] || host;
}(hostname.replace(/^[^.]+\.|(100)?\.[^.]+$/g, ''));

var ENV = isClient ? getEnv().env : 0; // 生成会话级别sessionid

export var HB_SESSION_ID_KEY = 'hbsessionid';

if (isClient) {
  // 设置会话级别的cookie，用于会话级别的数据跟踪分析
  !cookie.get(HB_SESSION_ID_KEY) && cookie.set(HB_SESSION_ID_KEY, uuid());
}
/**
 * 上报路径相关的配置
 *
 * @enum {string|number}
 */


export var Config = {
  /**
   * 上报域名
   */
  DOMAIN: DOMAIN,

  /**
   * 上报域名
   */
  QINGZHOU_DOMAIN: QINGZHOU_DOMAIN,

  /**
   * 项目标识名，格式：业务线-产品标识
   */
  NAME: NAME,

  /**
   * 宿主标识
   */
  ENV: ENV,

  /**
   * 配置提交上报的 HTTP VERB
   */
  VERB: 'post',

  /**
   * PV 的上报路径
   */
  PV: 'pv0.gif',

  /**
   * 点击、展开的上报路径
   */
  GS: 'gs.gif',

  /**
   * 性能相关指标上报路径
   */
  PERF: 'perf.gif',

  /**
   * 时间统计相关的上报路径
   */
  TIME: 'time.gif',

  /**
   * 数据追踪的上报路径
   */
  TRACE: 'trace.gif',

  /**
   * 页面停留时长的上报路径
   */
  STAY: 'stay.gif',

  /**
   * 批量上报，主用于视频相关的上报
   */
  BATCH: 'batch_event.gif',

  /**
   * metric 服务请求路径，用于上报点展滚动等数据
   */
  METRIC: 'metric.gif',

  /**
   * gid 服务请求路径
   */
  GID: 'habo/gid.js',

  /**
   * 是否延迟发送请求，默认开启
   */
  DELAY: true,

  /**
   * 业务相关的用户id， 存于Cookie中的名字， 比如， uid、 user_id、 __user_id__等， 可以支持业务方根据自己情况自定义。 用于后续可以用此id来快速定位问题
  */
  UID_COOKIE_NAME: 'uid',

  /**
   * 轻舟上用来区分不同应用的标识，取自擎天云上服务标识nid
   */
  APPNID: ''
  /**
   * 上报接口性能数据到轻舟开关
   */
  // ENABLE_QINGZHOU_PERF: true

};
/**
 * 全局追踪统计的用户唯一标识
 *
 * @type {string}
 */

export var trackID = isClient ? cookie.get('__track_id__') : cookie.get('GID');
/**
 * 登录户标识，默认取 user_id
 *
 * @type {string}
 */

export var userID = isClient ? cookie.get(Config.UID_COOKIE_NAME) : '';
/**
 * 需要透传的公共参数，比如 abtest等
 */

export var publicParams = {};
/**
 * 全局附加字段
 *
 * @type {Object}
 */

export var extraData = _objectSpread({
  gid: ''
}, commonParamsFromApp);
/**
 * 注意 NAME 上报
 *
 * @function
 * @param {string} queryString 要注入的源数据
 * @return {string} 返回注入 name=NAME 后的源数据
 */

export var injectCommonField = function injectCommonField(queryString, addionalParams) {
  if (!queryString) {
    return '';
  } // 注入业务线-产品代号
  // 如果自定义的参数中含有 name，取自定义的参数中的 name， 否则使用 Config.NAME


  if (!/(?:&|^)name=/.test(queryString) && !extraData.name) {
    if (!Config.NAME) {
      // eslint-disable-next-line no-console
      console.warn('no habo field `name`!');
    } // extraData中有客户端name字段,优先使用，覆盖配置项


    queryString += "&name=".concat(encodeURIComponent(Config.NAME));
  } // 注入客户端类型


  if (!/(?:&|^)env=/.test(queryString)) {
    queryString += "&env=".concat(encodeURIComponent(Config.ENV));
  }

  queryString = "".concat(queryString.replace(/(&|^)ver=[^&]+/g, ''), "&ver=").concat("2.2.2-alpha.4");
  queryString += "&".concat(toQuery(extraData));

  if (!/((?:^|&)t=)([^$&]*)/i.test(queryString)) {
    var now = (+new Date()).toString(36);
    queryString += "&t=".concat(now);
  }

  var type = addionalParams.type; // 注入 req_idx ，用于统计丢失率

  queryString += "&req_idx=".concat(getReqIdx(type, extraData.gid));
  return queryString.replace(/^&+/, '');
};
/**
 * 将公共字段和自定义数据合并，替换原有的 injectCommonField，在字符串上追加字段的不优雅难维护的操作
 *
 * @param {Object} params 自定义的上报信息
 * @param {Object} addionalParams 公共的上报信息
 * @return {Object} 合并之后的参数
 */

export function extendCommonField(params, addionalParams) {
  var _addionalParams$type = addionalParams.type,
      type = _addionalParams$type === void 0 ? '' : _addionalParams$type; // 严格控制顺序，
  // 公共参数中的 name 可以覆盖掉自定义参数中的name，此操作与上面原逻辑不一致，原逻辑可能导致自定义参数中的 name，污染原配置中的业务线名，在此优化
  // env、ver、t、req_idx是 h5 哈勃自有需要上报的保留字段
  // extraData 是 gid，和客户端传过来的参数
  // 客户端传过来的参数 有以下 10 个（app_type,habo_did,p_cuid,app_version,app_terminal,device_os,app_channel,name,device_platform,did）, 需要覆盖原有的name， did，其他 8 个字段，暂不与哈勃本身字段重复，如果重复，则用客户端公参值覆盖掉原有的值

  return _objectSpread(_objectSpread({}, params), {}, {
    name: encodeURIComponent(Config.NAME),
    env: encodeURIComponent(Config.ENV),
    ver: "2.2.2-alpha.4",
    t: (+new Date()).toString(36),
    req_idx: getReqIdx(type, extraData.gid)
  }, extraData);
}
/**
 *  覆盖配置
 *
 * @function
 * @param {Object} defaults 覆盖上报相关的配置
 * @return {Object} 更新后的 Config
 */

export var setConfig = function setConfig(defaults) {
  return extend(Config, defaults);
};
/**
 * 设置用于透传上报的公共参数,
 * publicParams 数据会打平，只有一层，目的是兼容 get 请求发送数据格式、或者 post 请求 application/x-www-form-urlencoded 格式数据（key=value）
 *
 * @param {object} params 自定义的公共参数
 */

export var setPublicParams = function setPublicParams(params) {
  if (isPlainObj(params)) {
    var publicParamsTemp = {};
    Object.keys(params).forEach(function (key) {
      // 在这里暂不 encodeURIComponent ，因为后续参数会自动通过 toQuery 进行 encodeURIComponent， 防止多次 encode 后，解码麻烦
      params[key] && (publicParamsTemp[key] = JSON.stringify(params[key]));
    });
    Object.assign(publicParams, publicParamsTemp);
  }
};
var readyHandlerList = [];
/**
 * 判断config是否初始化完毕
 */

export var isReady = function isReady() {
  return readyHandlerList === null;
};
/**
 * 注册初始化完毕回调
 *
 * @param {Function} 回调函数
 */

export var onReady = function onReady(handler) {
  if (isReady()) {
    handler();
    return;
  }

  readyHandlerList.push(handler);
};

var execOnReady = function execOnReady() {
  readyHandlerList && readyHandlerList.forEach(function (handler) {
    return handler();
  });
  readyHandlerList = null;
};
/**
 * 初始化全局用户相关参数
 */


export var initExtraData = function initExtraData() {
  extraData.gid = cookie.get('GID'); // 如果是在客户端，用于覆盖掉h5哈勃的gid

  if (isInGaoTuApp && commonParamsFromApp.gid) {
    extraData.gid = commonParamsFromApp.gid;
  }

  if (extraData.gid || !isClient) {
    execOnReady();
    return;
  }

  delay(function () {
    // 通过file协议访问本地静态文件时手动拼接https协议请求cdn上gid.js文件
    var isFileProtocol = document && document.location.protocol === 'file:';
    var GIDUrl = isFileProtocol ? "https:".concat(Config.DOMAIN).concat(Config.GID) : "".concat(Config.DOMAIN).concat(Config.GID);
    loadScript(GIDUrl, function () {
      extraData.gid = cookie.get('GID');
      return execOnReady();
    });
  })();
};